{
  "nav_zuerich": "Zürich",
  "nav_rapperswil": "Rapperswil & Zürichsee",
  "nav_einsiedeln": "Einsiedeln & Ybrig",
  "l_opening_hours": "Opening hours",
  "l_contact": "Contact",
  "l_prices": "Prices",
  "Monday": "Monday",
  "Tuesday": "Tuesday",
  "Wednesday": "Wednesday",
  "Thursday": "Thursday",
  "Friday": "Friday",
  "Saturday": "Saturday",
  "Sunday": "Sunday",
  "l_address": "Address",
  "l_email": "Email",
  "l_telephone": "Telephone",
  "l_homepage": "Homepage",
  "l_place": "Place",
  "l_route": "Route",
  "l_change_map_style": "Change map style",
  "l_filter_categories": "Filter categories",
  "l_to_overview": "Go to overview",
  "txt_intro_h": "Discover, eat, drink, sleep, party and relax in Zürich and surroundings",
  "txt_intro_1": "Discover Zürich and its surroundings anew! Whether you are a local or a tourist, here you will find useful information on where to eat, drink, sleep, party and relax. Immerse yourself in the diversity of our region.",
  "txt_intro_2_zuerich": "Zürich, the pulsating economic and cultural metropolis of Switzerland, offers a unique mix of tradition and modernity. Discover the charming alleys of the old town, the lively Bahnhofstrasse, Lake Zurich and the numerous museums and theaters.",
  "txt_intro_2_rapperswil": "Rapperswil on Lake Zurich is a picturesque town with a historic old town, a beautiful castle and an impressive rose garden. From here you can explore Lake Zurich, admire the surrounding mountains and enjoy the peace and quiet of nature.",
  "txt_intro_2_eyz": "Einsiedeln is a famous pilgrimage site with an impressive monastery complex. Ybrig is a region with numerous hiking trails and opportunities for winter sports. Here you will find peace and relaxation amidst the impressive Swiss Alps."
}